import { useState, useEffect } from 'react';
import { Heading } from '@components/Heading';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { UPDATE_BANK_ACCOUNT_CONSENT } from '../../constants';
import { useAuthHttp } from '../../hooks';
import { FloxSpinner } from '@tailwindComponents/FloxSpinner';

export function UpdateFinancialInformation() {
  const authHttp = useAuthHttp();
  const [isUpdatingBankAccountConsent, setIsUpdatingBankAccountConsent] =
    useState(true);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const handleUpdateBankAccountConsent = async () => {
    try {
      const { data } = await authHttp.post(
        UPDATE_BANK_ACCOUNT_CONSENT,
        {
          oneTimeToken: searchParams.get('one-time-token'),
        },
        { headers: { 'Content-Type': 'application/json' } }
      );
      if (data.businessProfileWithFinancialData) {
        navigate('/profile');
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsUpdatingBankAccountConsent(false);
    }
  };

  useEffect(() => {
    handleUpdateBankAccountConsent();
  }, []);

  if (isUpdatingBankAccountConsent) {
    return (
      <div className='flex justify-center items-center h-[50vh]'>
        <div className='flex flex-col items-center gap-16'>
          <Heading as='h3' size='xs'>
            Authorising bank account consent...
          </Heading>
          <FloxSpinner size='lg' />
        </div>
      </div>
    );
  }

  return (
    <div className='flex justify-center items-center h-[50vh]'>
      <Heading as='h3' size='xs'>
        Failed to update bank account consent. Please try again.
      </Heading>
    </div>
  );
}
